@for (item of items; track $index) {
  <app-card>
    <app-card-header>
      <div class="skeleton skeleton-title"></div>
    </app-card-header>
    <app-card-body>
      @if (variant() === 'tiles') {
        <!-- тайлы 4 в ряд — как .block на главной -->
        <div class="skeleton-tiles">
          @for (child of childItems; track $index) {
            <div class="skeleton skeleton-tile"></div>
          }
        </div>
      } @else {
        <!-- дочерние блоки — по форме как вложенные карточки -->
        <div class="skeleton-children">
          @for (child of childItems; track $index) {
            <div class="skeleton skeleton-child"></div>
          }
        </div>
      }
    </app-card-body>
  </app-card>
}
